import { useBranchConfiguration } from '@/hooks/useBranchConfiguration.ts';

/**
 * Returns whether the customer menu should be shown, based on a backend
 * availability check (digitalMenuEnabled).
 */
export const useCustomerMenuEnabled = (
  brandId: string | undefined,
  outletId: string | undefined
) => {
  const { data, isLoading, isFetching, error } = useBranchConfiguration({
    brandId,
    outletId,
    select: data => Boolean(data?.digitalMenuEnabled),
  });

  return {
    enabled: data,
    isLoading: isLoading || isFetching,
    error,
  } as const;
};
